import { useEffect } from 'react'
import ImageSlide from './ImageSlide';
import VideoSlide from './VideoSlide';

const Carousel = (props) => {

    const {
        currentIndex,
        slides,
        isMobile,
    } = props;

    useEffect(() => {
        if (slides[currentIndex].color === 'black') {
          document.documentElement.style.setProperty("--text-color", "#000000");
        } else {
          document.documentElement.style.setProperty("--text-color", "#FFFFFF");
        }
      }, [slides, currentIndex]);
  return (
    <section className='carousel__outer-wrapper'>

        {slides.map((slide, index) => {
              if(slide.coverVideo === null){
                return <ImageSlide {...{
                  slide, 
                  currentIndex, 
                  index,
                  isMobile
              }} key={index}/>
              } else {
                return <VideoSlide {...{
                  slide, 
                  currentIndex, 
                  index,
                  isMobile
                }} key={index} />
              }


        })}
    </section>
  )
}

export default Carousel